import { Caption } from '@liveauctioneers/hammer-ui-core/text';

import { ItemCardPriceRow } from '@/components/GridItemCard/Card/components/ItemCardPriceRow/ItemCardPriceRow';
import ItemCardMenu from '@/components/ItemCard/components/Menu/ItemCardMenu';
import { useAppSelector } from '@/redux/hooks';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import {
    getItemSummaryBidCount,
    getItemSummaryIsBuyNowOnly,
    getItemSummaryIsLocked,
    getItemSummaryIsPassed,
    getItemSummaryIsPaused,
    getItemSummaryIsSold,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { getLiveItemStatusOpen } from '@/redux/modules/liveItemStatus';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export type CardPriceProps = {
    enterLinkHoverState: () => void;
    isCardHovered: boolean;
    isLinkHovered: boolean;
    isMobile: boolean;
    itemId: number;
    leaveLinkHoverState: () => void;
};

export const CardPrice = ({
    enterLinkHoverState,
    isCardHovered,
    isLinkHovered,
    isMobile,
    itemId,
    leaveLinkHoverState,
}: CardPriceProps) => {
    const formatMessage = useAppFormatMessage();
    const isLoggedIn = useAppSelector(isUserLoggedIn);
    const bidCount = useAppSelector((state) => getItemSummaryBidCount(state, itemId));
    const isBuyNowOnly = useAppSelector((state) => getItemSummaryIsBuyNowOnly(state, itemId));
    const isSold = useAppSelector((state) => getItemSummaryIsSold(state, itemId));
    const isPassed = useAppSelector((state) => getItemSummaryIsPassed(state, itemId));
    const isPaused = useAppSelector((state) => getItemSummaryIsPaused(state, itemId));
    const isLocked = useAppSelector((state) => getItemSummaryIsLocked(state, itemId));

    const isLotOpen = useAppSelector((state) => getLiveItemStatusOpen(state, itemId));

    const isPending = isLocked && !isPassed && !isSold && !isLotOpen;

    return (
        <section
            className="flex justify-between [grid-area:currentbidprice]"
            data-testid="timedPlusMyItemsCardPrice"
        >
            <section className="flex items-center">
                <ItemCardPriceRow
                    isHovered={isLinkHovered}
                    itemId={itemId}
                    onMouseEnter={enterLinkHoverState}
                    onMouseLeave={leaveLinkHoverState}
                />
                {!isSold && !isPassed && !isPending && !isPaused && !isBuyNowOnly && bidCount > 0 && (
                    <Caption
                        className="ml-2xs"
                        color="secondary"
                        data-testid="timedPlusMyItemCardBidCount"
                    >
                        {formatMessage(['itemBidding', 'bid'], { values: { bidCount } })}
                    </Caption>
                )}
            </section>
            {isLoggedIn && !isMobile && (
                <ItemCardMenu
                    itemId={itemId}
                    showIcon={isCardHovered}
                />
            )}
        </section>
    );
};
